function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FilterInput } from './filter-input.js';
import { NoMatch } from './no-match.js';
import { filterIgnored, checkIfValidOption } from './option-helpers.js';
export class FilterableMenu extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "state", {
      filter: ''
    });

    _defineProperty(this, "onFilterChange", _ref => {
      let {
        value
      } = _ref;
      this.setState({
        filter: value
      });
    });
  }

  render() {
    const {
      dataTest,
      options,
      onChange,
      selected,
      empty,
      handleClose,
      handleFocusInput,
      placeholder,
      noMatchText,
      Menu
    } = this.props;
    const {
      filter
    } = this.state;
    const menuProps = {
      onChange,
      selected,
      empty,
      handleClose,
      handleFocusInput,
      dataTest
    };
    const renderedOptions = filterIgnored(options); // If there are no options or there's no filter, just pass everything through

    if (React.Children.count(renderedOptions) === 0 || !filter) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FilterInput, {
        dataTest: "".concat(dataTest, "-filterinput"),
        placeholder: placeholder,
        value: filter,
        onChange: this.onFilterChange
      }), /*#__PURE__*/React.createElement(Menu, _extends({}, menuProps, {
        options: options
      })));
    }

    const filtered = React.Children.map(options, child => {
      const isValidOption = checkIfValidOption(child); // Filter it out if it's an invalid option

      if (!isValidOption) {
        return null;
      }

      const {
        label
      } = child.props; // Filter by label, because that's the part of an option that's displayed to the user

      const match = label.toLowerCase().includes(filter.toLowerCase());
      return match ? child : null;
    });
    const hasMatch = React.Children.count(filtered) > 0;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FilterInput, {
      dataTest: "".concat(dataTest, "-filterinput"),
      placeholder: placeholder,
      value: filter,
      onChange: this.onFilterChange
    }), hasMatch ? /*#__PURE__*/React.createElement(Menu, _extends({}, menuProps, {
      options: filtered
    })) : /*#__PURE__*/React.createElement(NoMatch, {
      message: noMatchText
    }));
  }

}
FilterableMenu.propTypes = {
  Menu: PropTypes.elementType.isRequired,
  dataTest: PropTypes.string.isRequired,
  noMatchText: PropTypes.string.isRequired,
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
  empty: PropTypes.node,
  handleClose: PropTypes.func,
  handleFocusInput: PropTypes.func,
  options: PropTypes.node,
  placeholder: PropTypes.string,
  onChange: PropTypes.func
};